export function isMusical(event) {
    return event.category === "musical";
}
//# sourceMappingURL=all.js.map